import axios from 'axios'
import { Message } from 'element-ui'
import router from '../router'
console.log(process.env.NODE_ENV)
// create an axios instance
const service = axios.create({
  baseURL: process.env.NODE_ENV === 'development' ? '/' : location.protocol + '//api.lekanghuli.com',
  headers: {
    'Content-Type': 'application/json;charset=UTF-8'
  },
  timeout: 90000 // request timeout
})

// request拦截器 request interceptor
service.interceptors.request.use(
  config => {
    const data = config.data
    if (data instanceof FormData) {
      const token = sessionStorage.getItem('AuthToken') || ''
      const tokenKey = config.multipartTokenField || 'token'
      if (token) {
        const hasKey = typeof data.has === 'function' ? data.has(tokenKey) : false
        if (!hasKey) {
          data.append(tokenKey, token)
        }
      }
      delete config.headers['Content-Type']
      return config
    }
    config.data = {
      head: {
        token: config.noToken ? '' : (sessionStorage.getItem('AuthToken') || '')
      },
      body: {
        ...data
      }
    }
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)
// response 拦截器
service.interceptors.response.use(
  response => {
    const res = response.data
    if (res.msg === '登录过期') {
      router.push({ path: '/login' })
    }
    return Promise.resolve(res)
  },
  error => {
    console.log('error', error)
    if (!(error.config && error.config.silent)) {
      Message.error('系统异常，请稍后重试')
    }
    return Promise.reject(error)
  }
)

export default service
